import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import JustificationModal from '@components/JustificationModal';
import ModalDomains from '@components/Blacklist/ModalDomains';


import { getAllBlacklistDomains, addtDomainToBlacklist, deleteDomain } from '@actions/blacklist';
import { sendActionToBitacora  } from '@actions/bitacora';

class BlacklistDomains extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      domains: [],
      showModalDominio: {
        isVisible: false,
        title: '',
        description: '',
        value: '',
        descriptionsValue: null,
        label: '',
        continueAction: null,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      // lazyParams: {
      //   first: 0,
      //   rows: 10,
      //   page: 0,
      // }
    };
  }

  async componentDidMount() {
    await this.loadData();
    return this.setState({loadingPage: false})
  }

  loadData = async () => {
    const { getAllBlacklistDomains } = this.props;
    this.setState({ loadingTable: true });
    const response = await getAllBlacklistDomains();
    if (!response?.status) {
      return this.setState({
        domains: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  onAddDomains = () => {
    const { t } = this.props
    this.setState({
      showModalDominio: {
        isVisible: true,
        value: '',
        title: t('Agregar dominio'),
        description: t('Escribe un dominio de correo, al cual no se le permitira ejercer registro con este dominio'),
        btnOkLabel: t('Agregar'),
        continueAction: ({domain}, justification) => this.addDomain(domain, justification),
      },
    });
  }

  addDomain = async (newDomain, justification) => {
    const { t, addtDomainToBlacklist, sendActionToBitacora } = this.props
    this.setState({loadingTable: true})

    const response = await addtDomainToBlacklist(newDomain)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaDominioCorreo',
        reason: `${newDomain} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  }

  onConfirmDeleteDomain = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: data.dominio}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteDomain(data, justification),
      },
    });
  }
  
  onDeleteDomain = async (data, justification) => {
    const { t, deleteDomain, sendActionToBitacora } = this.props;
    this.setState({loadingTable: true})
    const response = await deleteDomain({domain: data.dominio, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'bajaDominioCorreo',
        reason: `${data.dominio} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  };

  onHideModalDomain = () => {
    this.setState({
      showModalDominio: {
        isVisible: false,
      },
    });
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  templateDelete = (node, detail) => (<div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-trash"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onConfirmDeleteDomain(node)}
      />
    </div>)


  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  render() {
    const { t, history } = this.props;
    const { domains, loadingTable, showModalDominio, showModalJustification } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        <Button
          label={t('Agregar dominio')}
          className="p-button-primary"
          onClick={() => this.onAddDomains() }
        />
      </>
    );

    return (
      <div className="p-grid p-justify-center">
        <div className="p-col-12">
          <Header title={t('Lista negra de dominios')} rightComponent={rightHeader} />
        </div>
        <div className="p-col-12 p-lg-8 p-mt-2">
        <div className="card">
            <DataTable
              value={domains}
              lazy
              loading={loadingTable}
              className="table-languages"
              onRowReorder={this.onRowReorder}
            >
              <Column
                header={t('Dominio')}
                field="dominio"
                body={this.columnResponsive}
              />
              <Column
                header={t('Eliminar')}
                body={this.templateDelete}
                className="column-action p-text-center-lg"
              />
            </DataTable>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        { showModalDominio.isVisible && (
          <ModalDomains
            display={showModalDominio.isVisible}
            title={showModalDominio.title}
            description={showModalDominio.description}
            value={showModalDominio.value}
            btnOkLabel={showModalDominio.btnOkLabel}
            label={showModalDominio.label}
            onHidden={() => this.onHideModalDomain()}
            onContinueAction={showModalDominio.continueAction}
          />
        )}
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  getAllBlacklistDomains,
  addtDomainToBlacklist,
  deleteDomain,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BlacklistDomains);
